import { PrimitiveAtom, useAtom } from 'jotai'
interface IUsePagination {
  paginationAtom: PrimitiveAtom<object>
  initialValue?: object
}
export const usePagination = ({ paginationAtom, initialValue = { page: 1, pageSize: 10 } }: IUsePagination) => {
  const [pagination, setPagination] = useAtom(paginationAtom)

  const goToPage = (page: number) =>
    setPagination(() => {
      if (pagination) return { ...pagination, page }
      return { ...initialValue, page }
    })

  const setPageSize = (pageSize: number) =>
    setPagination(() => {
      if (pagination) return { ...pagination, page: 1, pageSize }
      return { ...initialValue, pageSize }
    })

  return {
    pagination: pagination || initialValue,
    goToPage,
    setPageSize,
  }
}
